// extracted by mini-css-extract-plugin
module.exports = {"logo-link":"_3HMztYehogRVMVjBv1qj-N"};